import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables/index';
import React, {FunctionComponent} from 'react';
import styled from 'styled-components';

import LaunchDashboardSvg from '../media/hexagonIconImage/icons/launch_dashboard.svg';

import {ExternalLink, Link, pxToEm} from './globalStyles';
import HexagonIconImage, {HexagonBaseBg} from './hexagonIconImage';

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const StyledExternalLink = styled(ExternalLink)`
  display: flex;
  align-items: center;
`;

const StyledContent = styled.div`
  padding: 1em 1em 1em 2.5em;
  background-color: white;
  border: 1px solid ${baseVariables.colors.darkBlueGray};
  border-radius: ${baseVariables.sizes.borderRadius};
  box-shadow: 0px 0px 29px rgba(0, 0, 0, 0.25);
  transform: translateX(-2em);
  z-index: -1;
  font-weight: 500;
  font-size: ${pxToEm(22)}em;
  color: ${baseVariables.colors.midnight};
`;

interface Props {
  to: string;
  external?: boolean;
  hexagonIconSrc?: string;
}

const SeeItInActionButton: FunctionComponent<Props> = ({to, external = false, hexagonIconSrc = LaunchDashboardSvg}) =>
  external ? (
    <StyledExternalLink href={to}>
      <HexagonIconImage baseBg={HexagonBaseBg.Blue} iconSrc={hexagonIconSrc} />
      <StyledContent>See it in action</StyledContent>
    </StyledExternalLink>
  ) : (
    <StyledLink to={to}>
      <HexagonIconImage baseBg={HexagonBaseBg.Blue} iconSrc={hexagonIconSrc} />
      <StyledContent>See it in action</StyledContent>
    </StyledLink>
  );

export default SeeItInActionButton;
